import {SignIn} from 'domain/usecases';
import {RemoteSignIn} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeRemoteAuthentication = (): SignIn =>
	new RemoteSignIn(makeBFFApiUrl(EntryFlowEndPoints.signin), makeAuthorizeHttpClientDecorator());
